import { render, staticRenderFns } from "./PackagingDetailForm.vue?vue&type=template&id=f57851b6&scoped=true"
import script from "./PackagingDetailForm.vue?vue&type=script&lang=js"
export * from "./PackagingDetailForm.vue?vue&type=script&lang=js"
import style0 from "./PackagingDetailForm.vue?vue&type=style&index=0&id=f57851b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57851b6",
  null
  
)

export default component.exports